import { axiosInstance } from "./BaseService" 

export async function getConsolidatedPredictions() {
  try {
    const response = await axiosInstance.get('/predictions/consolidated');
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function getConsolidatedIndexes() {
  try {
    const response = await axiosInstance.get('/predictions/consolidatedIndexes');
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function getPredictionsByProduct(productIds) {
  try {
    const appendProductIds = Array.isArray(productIds) ? productIds.join(",") : productIds;
    const response = await axiosInstance.get(`/predictions/byProducts/?productIds=${appendProductIds}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function getLastSixMonthsPredictions() {
  try {
    const response = await axiosInstance.get('/predictions/last-six-predictions');
    return response.data;
  } catch (err) {
    throw err;
  }
}